<template>
  <div>
    <v-container class="print-toolbar">
      <v-card class="d-flex pa-2">
        <v-btn text color="primary" @click="print">
          <v-icon left>fas fa-print</v-icon>Imprimir
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn x-small fab color="primary" class="elevation-1" @click="$router.push('/')">
          <v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
      </v-card>
    </v-container>
    <div class="d-flex justify-center mb-10">
      <div class="wrap-doc" v-html="certificate"></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    certificate() {
      return this.$store.state.certificate
    }
  },
  methods: {
    print() {
      window.print()
    }
  },
  mounted() {
    if(!this.certificate) {
      this.$router.push('/')
    }
  }
}
</script>

<style>
@media screen {
  .wrap-doc {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
}
@media print {
  .header, .footer, .print-toolbar {
    display: none;
  }
}
</style>